function PageNotFound({title}) {
  return (
    <div data-title={title} className={`PageNotFound`}>
      PageNotFound
    </div>
  );
}

export default PageNotFound;